<template>
  <div class="product-image-360" :class="{ 'product-fullscreen' : isFullscreen }">
    <transition name="fade" mode="out-in">
      <svg v-show="loading" class="spinner" viewBox="0 0 50 50">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
      </svg>
    </transition>
    <transition name="fade" mode="out-in">
      <ImageScrubber
        v-show="!loading"
        :width="canvasWidth"
        :height="canvasHeight"
        :image-data-array="canvasImageDataArray"
        :image-array="canvasImageArray"
        :alpha-channel-image-array="canvasAlphaChannelImageArray"
        @interaction.once="onInteraction"
      />
    </transition>
    <!-- <Fullscreen class="icon-fullscreen ma-3 svg-fill-none svg-stroke-black" @click="toggleFullscreen"></Fullscreen> -->
  </div>
</template>

<script>
// shift first item, remove product main image

import ImageScrubber from '@/atoms/ImageScrubber.vue'
// import Fullscreen from '@/assets/svg/fullscreen.svg'
import filter from 'lodash/filter'
import JSZip from 'jszip'
import sortBy from 'lodash/sortBy'

export default {
  name: 'ProductImage360',

  components: {
    ImageScrubber
  },

  props: {
    content: {
      type: Object
    },
    sku: {
      type: String
    }
  },

  mounted () {
    this.loading = true
    this.loadZipOfJpg()
  },

  data () {
    return {
      isFullscreen: false,
      canvasImageDataArray: [],
      canvasImageArray: [],
      canvasAlphaChannelImageArray: [],
      canvasWidth: 100,
      canvasHeight: 100,
      loading: false
    }
  },

  methods: {
    onInteraction () {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'generic_event',
          eventCategory: 'Clicks on Perfume Hotspot',
          eventAction: this.sku,
          eventLabel: '360 Interaction'
        })
      }
    },
    toggleFullscreen () {
      this.isFullscreen = !this.isFullscreen
      if (this.isFullscreen) {
        this.$events.emit('hideLogo')
      } else {
        this.$events.emit('showLogo')
      }
    },
    imagePromise (file) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => {
          resolve(img)
        }
        img.onerror = (e) => {
          reject(new Error('Cannot natively decode image'))
        }
        img.src = file
      })
    },

    async loadZipOfJpg () {
      const response = await this.axios.get('/media/' + this.content.id, { responseType: 'arraybuffer' })
      // color
      const zip = new JSZip()
      await zip.loadAsync(response.data)

      let color = filter(sortBy(zip.filter(f => f.indexOf('transparency') === -1), ['name']), { dir: false })
      color = filter(color, (img) => {
        return img.name.indexOf('__MACOSX') === -1 && img.name.indexOf('DS_STORE') === -1 && img.name.indexOf('/.') === -1
      })

      const frames = new Array(color.length)

      const transparency = filter(sortBy(zip.filter(f => f.indexOf('transparency') !== -1), ['name']), { dir: false })
      const alphaChannel = new Array(transparency.length)

      for (let i = 0; i < color.length; i++) {
        let file = await color[i].async('base64')
        // console.log(file)
        this.imagePromise('data:image/jpeg;base64,' + file).then(img => {
          this.canvasWidth = img.width
          this.canvasHeight = img.height
          this.$set(frames, i, img)
          return null
        }).catch(e => { throw e })

        if (transparency[i]) {
          file = await transparency[i].async('base64')
          this.imagePromise('data:image/jpeg;base64,' + file).then(img => {
            this.$set(alphaChannel, i, img)
            return null
          }).catch(e => { throw e })
        }
      }
      this.canvasImageArray = frames
      this.canvasAlphaChannelImageArray = alphaChannel
      this.canvasImageDataArray = []
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.product-image-360 {
  width: 100%;
  height: 100%;
  height: 75vh;
  overflow: hidden;
  position: relative;

  @include breakpoint ('sm-only') {
    max-width: 500px;
    max-height: 500px;
    margin: auto;
  }

  @include breakpoint ('xs-only') {
    max-width: 332px;
    max-height: 332px;
    margin: auto;
  }
}

.product-fullscreen {
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
  background-color: $c-white;
}

.icon-fullscreen {
  top: 0;
  left: 0;

  cursor: pointer;
  position: absolute;
  width: 40px;
  height: 40px;
}

.spinner .path {
  stroke: $c-white;
}
</style>
